const TOKEN_KEY = 'pendingInviteToken'
const EMAIL_KEY = 'pendingInviteEmail'

export const getStoredInviteToken = () => localStorage.getItem(TOKEN_KEY)

export const getStoredInviteEmail = () => localStorage.getItem(EMAIL_KEY)

export const persistInvite = (token: string, email?: string | null) => {
  localStorage.setItem(TOKEN_KEY, token)

  if (email) {
    localStorage.setItem(EMAIL_KEY, email)
  }
}

export const clearInvite = () => {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(EMAIL_KEY)
}
